import { Popover } from "antd";
import { Info } from "lucide-react";
import React from "react";
import { PROMPT_GUIDES, VetPromptModule } from "../promptGuides";
import styles from "./styles.module.scss";

export function PromptGuide({
  moduleId,
}: {
  moduleId: VetPromptModule;
  defaultOpen?: boolean;
}) {
  const guide = PROMPT_GUIDES[moduleId];
  if (!guide) return null;

  const content = (
    <div className={styles.popoverContent}>
      <p className={styles.summary}>{guide.summary}</p>
      <ul className={styles.bullets}>
        {guide.bullets.map((bullet) => (
          <li key={bullet}>{bullet}</li>
        ))}
      </ul>
      <p className={styles.exampleLabel}>Example structure</p>
      <pre className={styles.example}>{guide.exampleOutline}</pre>
    </div>
  );

  return (
    <Popover
      content={content}
      title={<span className={styles.popoverTitle}>How to prompt correctly</span>}
      trigger={["hover", "click"]}
      placement="bottomLeft"
      overlayClassName={styles.guidePopover}
    >
      <button
        type="button"
        className={styles.infoBtn}
        aria-label="How to prompt correctly"
      >
        <Info size={14} className={styles.infoIcon} />
      </button>
    </Popover>
  );
}
